<template>
    <div v-if="card==true"> 
        <splide :options="slider_options" class="w-full">
            <splide-slide v-for="item in list" :key="item.index">
                <fruit-card :fruit="item" />
            </splide-slide>
        </splide>
    </div>
    <div v-if="card==false">
        <div class="hidden w-full grid-cols-1 gap-8 p-2 md:grid md:grid-cols-5 md:pl-20 md:visible"> 
            <p>Nombre</p>
            <p>Precio</p>
            <p>Descripción</p>
            <p>Incremento</p>
            <p>Ultimos 7 dias</p>
        </div>
        <fruit-list-item v-for="item in list" :key="item.index" :fruit="item" />
    </div>
</template>

<script>
import FruitCard from './FruitCard.vue'
import FruitListItem from './FruitListItem.vue'
import { Splide, SplideSlide } from '@splidejs/vue-splide'

export default {
    components: {FruitCard, FruitListItem,Splide,SplideSlide},
    props: ['list','card','cols'],
    setup(props){
        console.log(props.list) 

        const slider_options = {
            rewind : true,
            width  : '100%',
            perPage: props.cols,
            gap    : '1rem',
            breakpoints: {
                640: {
                    perPage: 1,
                },
                900: {
                    perPage: 2,
                },
                1200: {
                    perPage: 3,
                },
            }
        }

        return{
            slider_options
        }
    }
}
</script>

<style>

</style>